<template>
  <div class="journey-modes">
    <span v-for="(item, index) in toggles" :key="index" class="journey-mode">
      <input
        type="radio"
        v-model="chosen"
        :id="`tgmag-journey-mode-${index}`"
        :ref="`radioMode${index}`"
        name="journey-mode"
        :value="item.code"
      />
      <label :for="`tgmag-journey-mode-${index}`">
        {{ item.label }}
        <img :src="icons[item.icon]" :alt="item.code" />
      </label>
    </span>
  </div>
</template>

<script>
export default {
  name: "JourneyModes",
  props: {
    value: {
      type: String,
      default: "JOURNEY_MODE_RETURN"
    },
    toggles: {
      type: Array,
      default: function() {
        return [
          {
            label: "One-way",
            code: "JOURNEY_MODE_SINGLE",
            icon: "single",
            disabled: false
          },
          {
            label: "Return",
            code: "JOURNEY_MODE_RETURN",
            icon: "return",
            disabled: true
          }
        ];
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.chosen = value;
      }
    },
    chosen: {
      immediate: true,
      handler(value) {
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
      chosen: null,
      icons: {
        single: null,
        return: null
      }
    };
  },
  created() {
    import("./single.svg").then(data => {
      this.icons.single = data.default;
    });
    import("./return.svg").then(data => {
      this.icons.return = data.default;
    });
  },
  mounted() {
    setTimeout(() => {
      for (var i = 0; i < this.toggles.length; i++) {
        const elem = this.$refs[`radioMode${i}`];
        if (elem && elem.length && elem[0].checked) {
          this.chosen = this.toggles[i].code;
          break;
        }
      }
    }, 20);
  }
};
</script>

<style scoped>
.journey-modes {
  display: flex;
  flex-direction: row;
}

.journey-mode {
  width: 100%;
  min-width: 100px;
  flex: 1 1 auto;
  display: flex;
}

.journey-mode label {
  display: block;
  border: 1px solid #b8b8b8;
  padding: 8px;
  width: 100%;
  text-align: center;
  transition-property: background-color, border-color, color, font-weight;
  transition-duration: 150ms;
  transition-timing-function: ease-out;
  font-size: 14px;
  font-weight: 500;
  color: #767676;
  cursor: pointer;
}

.journey-mode:first-child label {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.journey-mode:last-child label {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.journey-mode:first-child input[type="radio"]:not(:checked) + label {
  border-right-color: transparent;
}

.journey-mode:last-child input[type="radio"]:not(:checked) + label {
  border-left-color: transparent;
}

.journey-mode input {
  display: none;
}

.journey-mode input[type="radio"]:checked + label {
  border-color: #06a7a9;
  background-color: #edf9f9;
  color: #022f61;
  font-weight: 600;
}
</style>
